import themeGet from '@styled-system/theme-get'

import { Theme } from './'

export const themeFont = themeGet('fontFamily')

export function themeSpace<Props extends { theme: Theme }>(
  space: number | string,
): (props: Props) => number
export function themeSpace(space: number | string, theme: Theme): string
export function themeSpace(space: number | string, theme?: undefined | Theme) {
  const fn = themeGet(`space.${space}`)
  return theme ? fn({ theme }) || space : fn
}

export function themeColor<Props extends { theme: Theme }>(
  color: string,
): (props: Props) => string
export function themeColor(color: string, theme: Theme): string
export function themeColor(color: string, theme?: undefined | Theme) {
  const fn = themeGet(`colors.${color}`)
  return theme ? fn({ theme }) || color : fn
}
